import usePersonalizarRouteSync from "./usePersonalizarRouteSync";

/** Componente nulo que sincroniza a rota /personalizar/* com o SubMenu. */
const PersonalizarRouteSync = () => {
	usePersonalizarRouteSync();
	return null;
};

export default PersonalizarRouteSync;
